var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7685 26.0978V15.5755H9.33594V12.8789H15.125V26.0978H11.7685Z",
    fill: "#EB5757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7356 16.2912C27.7356 17.4414 27.1133 18.4596 26.0762 19.0254C27.528 19.6288 28.4332 20.8923 28.4332 22.363C28.4332 24.7389 26.3212 26.2476 23.0213 26.2476C19.7213 26.2476 17.6094 24.7577 17.6094 22.4197C17.6094 20.9111 18.5899 19.6288 20.1173 19.0254C19.0047 18.4031 18.2882 17.3472 18.2882 16.197C18.2882 14.0848 20.1363 12.7461 23.0025 12.7461C25.9064 12.7461 27.7356 14.1227 27.7356 16.2912ZM20.7773 22.0803C20.7773 23.1929 21.5693 23.8152 23.0213 23.8152C24.4732 23.8152 25.2841 23.2119 25.2841 22.0803C25.2841 20.9867 24.4732 20.3643 23.0213 20.3643C21.5692 20.3643 20.7773 20.9866 20.7773 22.0803ZM21.1168 16.4797C21.1168 17.4228 21.7957 17.9505 23.0213 17.9505C24.247 17.9505 24.9258 17.4226 24.9258 16.4797C24.9258 15.4994 24.247 14.9525 23.0213 14.9525C21.7955 14.9525 21.1168 15.4994 21.1168 16.4797Z",
    fill: "#EB5757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5148 14.2522C35.0728 15.8991 35.3558 17.6218 35.3558 19.3788C35.3558 28.1885 28.1885 35.3558 19.3787 35.3558C10.5688 35.3558 3.40136 28.1885 3.40136 19.3788C3.40136 10.5688 10.5687 3.4017 19.3786 3.4017C21.1358 3.4017 22.8583 3.68456 24.5052 4.24282V0.687318C22.8418 0.231345 21.1238 0 19.3787 0C8.69331 0 0 8.6933 0 19.3788C0 30.0642 8.69331 38.7576 19.3787 38.7576C30.0641 38.7576 38.7572 30.0642 38.7572 19.3788C38.7572 17.6337 38.526 15.9157 38.07 14.2522H34.5148Z",
    fill: "#EB5757"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0529 5.31735V1.60156H30.381V5.31735H26.6875V7.98907H30.381V11.7047H33.0529V7.98907H36.7684V5.31735H33.0529Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18);
export default __webpack_public_path__ + "static/media/18+.08a364f572a72dba9535a201d86c20c9.svg";
export { ForwardRef as ReactComponent };